import {Box, Divider, useColorModeValue} from "@chakra-ui/react";

function CategoryItemDivider(props) {
    const CategoryItemDividerBG = useColorModeValue('#F9FAFA', '#3D3D3D')
    return (
        <Box pl={4} pr={4} pt={4} bg={CategoryItemDividerBG}>
            <Divider variant='dashed' opacity='1' color='red'/>
        </Box>
    )
}

export default CategoryItemDivider